module.exports = __webpack_public_path__ + "static/img/info_big_image.8082cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/profile/info_big_image.png
// module id = xJik
// module chunks = 1